import { useRouter } from 'next/router'
import { useCarReviewsHubTracking } from '@cinch-nx/data-tracking'
import { HubCardSkeleton } from '@cinch-nx/landing-ui-shared'
import { NoReviews } from '../no-reviews/no-reviews'

import { ReviewCard } from '../review-card/review-card'
import styles from './review-cards-list.module.css'
import type { CarReviewListItem } from '../../types'

type hasPath = { path: string }

export interface ReviewCardsListProps {
  reviews: CarReviewListItem[]
  page: number
  isLoading: boolean
  selectedMake?: string | null
  selectedModel?: string | null
}

export const ReviewCardsList: React.FC<ReviewCardsListProps> = ({
  reviews,
  page,
  isLoading = true,
  selectedMake,
  selectedModel,
}) => {
  const { isFallback } = useRouter()

  const { trackOnReviewCardClick } = useCarReviewsHubTracking()

  const filteredReviews = reviews?.filter(
    (item): item is typeof item & hasPath => !!(item && item.path),
  )

  if (isFallback || isLoading) {
    return (
      <div data-testid="skeletonPlaceHolder">
        {Array.from({ length: 10 }).map((_, idx) => (
          <HubCardSkeleton key={idx} featured={idx === 0} />
        ))}
      </div>
    )
  }

  return filteredReviews?.length > 0 ? (
    <ul>
      {filteredReviews?.map((item, idx) => (
        <li className={styles.listItem} key={item.id}>
          <a
            href={item.path}
            className={styles.link}
            aria-label={item.title}
            onClick={() => trackOnReviewCardClick(`${item.make} ${item.model}`)}
          >
            <ReviewCard
              title={item.title}
              image={item.heroImage}
              starRating={item.starRating}
              snippet={item.snippet}
              featured={idx === 0 && page === 1}
            />
          </a>
        </li>
      ))}
    </ul>
  ) : (
    <NoReviews selectedMake={selectedMake} selectedModel={selectedModel} />
  )
}
